import React from 'react'

import { Modal } from '@clientbase/clientbase-library'
import { useActiveMerchantForRecord } from 'lib/merchant-group'

import { ModalInstallmentDetailProvider } from './context'
import ModalInstallmentDetailBody from './ModalInstallmentDetailBody'

type ModalInstallmentDetailProps = {
  uuid: string
  handleCloseInstallmentDetail: (reloadTable?: boolean) => void
  isOpenInstallmentDetail: boolean
  setReloadTable?: React.Dispatch<React.SetStateAction<boolean>>
}

const ModalInstallmentDetail = ({
  uuid,
  handleCloseInstallmentDetail,
  isOpenInstallmentDetail,
  setReloadTable
}: ModalInstallmentDetailProps) => {
  // SC-10999: aberto da lista agregada do grupo, age na empresa do registro
  useActiveMerchantForRecord(isOpenInstallmentDetail ? uuid : undefined)

  return (
    <Modal
      disablePortal={false}
      handleClose={() => handleCloseInstallmentDetail(false)}
      open={isOpenInstallmentDetail}
      maxWidth="1150px"
      width="100%"
      height="calc(100%-200px)"
      maxHeight="90vh"
    >
      <ModalInstallmentDetailProvider>
        <ModalInstallmentDetailBody
          setReloadTable={setReloadTable}
          onClose={(v) => handleCloseInstallmentDetail(v)}
          uuid={uuid}
        />
      </ModalInstallmentDetailProvider>
    </Modal>
  )
}

export default ModalInstallmentDetail
